<script setup>
import { CardHeader } from '@dashhudson/dashing-ui';

const props = defineProps({
  email: { type: String, default: null },
  label: { type: String, default: null },
  image: { type: String, default: null },
});
</script>

<template>
  <div class="dash-flex dash-flex-col dash-gap-4">
    <CardHeader :avatar="{ image: props.image, size: 'sm' }" :title="props.label" />
    <div v-if="props.email" class="dash-flex dash-flex-col dash-gap-2">
      <span class="dash-typo-base">{{ props.email }}</span>
    </div>
  </div>
</template>
